import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = [
    "orderId",
    "playerId",
    "productId",
    "teamId",
    "customizationType",
    "draftRevisions",
    "revisionList",
    "draftRevisionsContainer",
    "importRecipeInput",
    "importRecipeError",
    "customizationTypes",
    "nextButton",
  ];

  get currentCustomizationType() {
    return this.customizationTypeTargets?.find((t) => t.checked)?.value;
  }

  get currentDraftRevisions() {
    return this.draftRevisionsTargets?.find((t) => t.checked)?.value;
  }

  connect() {
    this.params = JSON.parse(this.data.get("params"));

    this.loadRevisions(this.currentCustomizationType, 1);
  }

  paginationClick(event) {
    event.preventDefault();
    const page = event.target.dataset.page;
    this.loadRevisions(this.currentCustomizationType, page);
  }
  toggleDraftRevisionsContainer(customizationType) {
    if (this.hasDraftRevisionsContainerTarget) {
      const { draftRevisionCustomizationTypes } = this.params;
      const showDraftRevisions =
        draftRevisionCustomizationTypes.includes(customizationType);

      if (this.currentDraftRevisions == "true" && !showDraftRevisions) {
        this.draftRevisionsTargets?.find((t) => t.value == "false").click();
      }

      this.draftRevisionsContainerTarget.style.display = showDraftRevisions
        ? ""
        : "none";
    }
  }

  customizationTypeChange({ currentTarget: { value } }) {
    //this.toggleDraftRevisionsContainer(value);
    //   this.loadRevisions(this.currentCustomizationType, 1);
  }

  async loadRevisions(customizationType, page) {
    const currentPath = window.location.pathname;
    const currentQuery = window.location.search;
    const url = currentPath + currentQuery;

    const link = $("<a>")
      .css("display", "none")
      .attr("href", url + "&customization_type=" + customizationType)
      .attr("data-turbo-frame", "revision_section")
      .appendTo(document.body);

    link.get(0).click();

    link.remove();
  }

  draftRevisionsChange({ currentTarget: { value } }) {
    const currentPath = window.location.pathname;
    const currentQuery = window.location.search;
    const url = currentPath + currentQuery;

    const link = $("<a>")
      .css("display", "none")
      .attr("href", url + "&draft_revisions=" + value)
      .attr("data-turbo-frame", "revision_tag")
      .appendTo(document.body);

    link.get(0).click();

    link.remove();
  }

  useRevisionChanged({ currentTarget: { value } }) {
    const revisionsTable = document.getElementById('revisions_table');
    if (this.hasImportRecipeInputTarget) {
      if (value == "import_recipe") {
        this.importRecipeInputTarget.disabled = false;
        this.nextButtonTarget.disabled = true;
        if (revisionsTable) {
          revisionsTable.style.display = 'none';
        }

        if (this.hasCustomizationTypesTarget) {
          this.customizationTypesTarget.style.display = "none";
        }
      } else {
        this.importRecipeInputTarget.disabled = true;
        this.importRecipeInputTarget.value = "";
        this.importRecipeErrorTarget.style.display = "none";
        this.nextButtonTarget.disabled = false;
        if (revisionsTable) {
          revisionsTable.style.display = '';
        }

        if (this.hasCustomizationTypesTarget) {
          this.customizationTypesTarget.style.display = "";
        }
      }
    }
  }

  validateImportRecipe = $.debounce(() => {
    this.importRecipeErrorTarget.style.display = "none";
    this.nextButtonTarget.disabled = true;

    if (this.importRecipeInputTarget.value) {
      $.ajax(this.params.importRecipeValidationUrl, {
        method: "POST",
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify({ recipe_token: this.importRecipeInputTarget.value }),
      })
      .then((result) => {
        if (result.error) {
          this.importRecipeErrorTarget.textContent = result.error;
          this.importRecipeErrorTarget.style.display = "";
        } else {
          if (this.nextButtonTarget.dataset.hasCustomizationTypes === 'true' )
            this.nextButtonTarget.disabled = false;
        }
      });
    }
  }, 1000);
}
